import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/styles";
import {
  Grid,
  TextField,
  InputAdornment,
  CircularProgress,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import NewsCard from "./news/NewsCard";
import MonthListFilter from "./news/MonthListFilter";
import { callGetApiWithAuth } from "utils/api";
import moment from "moment";
import NoData from "components/NoData";

export default function PartnersPage(props) {
  const classes = useStyles();
  const [isLoadingList, setIsLoadingList] = useState(false);
  const [newsData, setNewsData] = useState([]);
  const [paginationParam, setPaginationParam] = useState({
    currentPage: 1,
    perPage: 5,
    total: 0,
  });
  const [searchParam, setSearchParam] = useState({
    month: moment().format("YYYY-MM"),
    title: "",
  });

  const loadNews = (paginationParam, searchParam) => {
    setIsLoadingList(true);
    let params = [];
    params["filter[month]"] = searchParam.month;
    params["filter[title]"] = searchParam.title;
    let query = Object.keys(params)
      .map((k) => k + "=" + params[k])
      .join("&");

    callGetApiWithAuth("news?" + query, onGetNewsData, onFailNewsData);
  };
  const onGetNewsData = (data) => {
    setIsLoadingList(false);
    setNewsData(data.data.data);
    setPaginationParam({
      ...paginationParam,
      total: data.data.total,
      perPage: data.data.per_page,
    });
  };
  const onFailNewsData = (errorMessage) => {
    setIsLoadingList(false);
  };

  const searchByTitle = (title) => {
    let searchParam_ = { ...searchParam, title };
    setSearchParam(searchParam_);
    let paginationParam_ = { ...paginationParam, perPage: 5 };
    loadNews(paginationParam_, searchParam_);
  };

  const searchByMonth = (month) => {
    let searchParam_ = { ...searchParam, month };
    setSearchParam(searchParam_);
    let paginationParam_ = { ...paginationParam, currentPage: 1 };
    setPaginationParam(paginationParam_);
    loadNews(paginationParam_, searchParam_);
  };

  useEffect(() => {
    if (props?.location?.state?.month) {
      searchByMonth(moment(props.location.state.month).format("YYYY-MM"));
    } else {
      searchByMonth(moment().format("YYYY-MM"))
    }
  }, [])

  return (
    <div className={classes.container}>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <TextField
            onChange={(e) => searchByTitle(e.target.value)}
            className={classes.inputField}
            placeholder="Search News"
            variant="outlined"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={3} className={classes.monthGrid}>
            <Grid
              item
              xs={12}
              sm={12}
              md={8}
              lg={9}
              xl={10}
              className={classes.newsDataGrid}
            >
              {!isLoadingList ? (
                <>
                  {newsData && newsData.length == 0 ? (
                    <Grid item xs={12} justifyContent={"center"}>
                      <NoData showImage errorText="No News" />
                    </Grid>
                  )
                  :
                    <NewsCard data={newsData} />
                  }
                </>
              ) : (
                <div className={classes.loadingRoot}>
                  <CircularProgress size={48} />
                </div>
              )}
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={4}
              lg={3}
              xl={2}
              className={classes.rightMonthListFilter}
            >
              <MonthListFilter
                handleSearch={searchByMonth}
                searchParam={searchParam}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  container: {
    position: "relative",
    minHeight: 400,
  },
  inputField: {
    width: 300,
    height: 36,
    background: "#F9F9F9",
    "& .MuiOutlinedInput-root": {
      height: 36,
    },
    [theme.breakpoints.only("xs")]: {
      width: "100%",
    },
  },
  newsDataGrid: {
    "@media (max-width: 660px)": {
      width: "100%",
      maxWidth: "100%",
      flexBasis: "100%",
    },
  },
  monthGrid: {
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column-reverse",
    },
  },
  rightMonthListFilter: {
    display: "block !important",
  },
  // topMonthListFilter: {
  //   display: "none !important",
  //   [theme.breakpoints.down("xs")]: {
  //     display: "block !important",
  //   },
  // },
  loadingRoot: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
  },
}));
